import debounce from "lodash/debounce";
import { useMemo } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDebounce<T extends (...args: any[]) => any>(
    fn: T,
    ms: number
): (...funcArgs: Parameters<T>) => ReturnType<T> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return useMemo(() => debounce(fn, ms), [fn, ms]) as ReturnType<T>;
}
